<div class="content" [ngClass]="firmante.seleccionado ? 'seleccionado' : ''" [class.formularios-firmante--inline]="inlineMode">
  <div class="flex" *ngIf="!inlineMode" (click)="mostrarEstado(firmante)">
    <h6>{{firmante.tipoFirmante.desc}}</h6>
    <svg class="icon-arrow" [ngClass]="firmante.seleccionado ? 'icon-arrow-up':''">
      <use xlink:href="#icon-arrow"></use>
    </svg>
  </div>
  <div *ngIf="inlineMode || firmante.seleccionado">
    <app-formularios-grupo-casillas *ngFor="let form of casillasMostrarFormArray.controls ; let i = index"
                                    [firmante]="firmante"
                                    [formulario]="convertirAForm(i)"
                                    [indexMostrar]="i"
                                    [inlineMode]="inlineMode"
                                    (addForm)="showNewForm()"
                                    (deleteForm)="deleteFormulario($event)"
                                    #formulariosGrupoCasillasComponent></app-formularios-grupo-casillas>
  </div>
</div>
<div>
